/**
 * Converts HSL values to a CSS hsl() string
 * @param h - Hue (0-360)
 * @param s - Saturation (0-100)
 * @param l - Lightness (0-100)
 * @returns CSS hsl() string
 */
export function hslToCSS(h: number, s: number, l: number): string {
  return `hsl(${h}, ${s}%, ${l}%)`
}

/**
 * Converts an HSL array to a CSS hsl() string
 * @param hsl - Array of [hue, saturation, lightness]
 * @returns CSS hsl() string or undefined if invalid input
 */
export function hslArrayToCSS(hsl: number[] | undefined): string | undefined {
  if (!hsl || hsl.length !== 3) return undefined
  return hslToCSS(hsl[0], hsl[1], hsl[2])
}
